import type { AdminRouter } from '@pelicargo/api';
import { createTRPCReact } from '@trpc/react-query';
import { inferRouterInputs, inferRouterOutputs } from '@trpc/server';

export type TrpcOutputs = NonNullable<inferRouterOutputs<AdminRouter>>;
export type TrpcInputs = inferRouterInputs<AdminRouter>;
export const trpc = createTRPCReact<AdminRouter>();
